import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { hu } from 'date-fns/locale';
import { api } from '@/lib/db';
import { useAuth } from '@/contexts/AuthContext';
import { Card, Button } from '@/components/ui/Components';
import SafeIcon from '@/common/SafeIcon';

const Reviews = () => {
  const { user } = useAuth();
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    const data = await api.getReviews(user.business_id);
    setReviews(data);
  };

  const exportCSV = () => {
    const headers = ['Időpont,Beküldő adatai,Értékelés,Visszajelzés'];
    const rows = reviews.map(r =>
      `${format(new Date(r.created_at), 'yyyy-MM-dd HH:mm')},"${r.name} <${r.email}>",${r.star_rating},"${(r.message || '').replace(/"/g, '""')}"`
    );
    const csv = [...headers, ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'visszajelzesek.csv';
    a.click();
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-black text-gray-900 dark:text-white">Beérkezett visszajelzések</h1>
          <p className="text-gray-500 dark:text-gray-400">Azok a visszajelzések, amik nem kerültek ki a Google-re.</p>
        </div>
        <Button onClick={exportCSV} variant="outline">
          <SafeIcon name="Download" className="w-4 h-4 mr-2" /> CSV Export
        </Button>
      </div>

      <Card className="overflow-hidden border-0 shadow-sm ring-1 ring-black/5 dark:ring-white/10">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <thead className="bg-gray-50 dark:bg-gray-700">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Időpont</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Beküldő adatai</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Értékelés</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Visszajelzés</th>
              </tr>
            </thead>
            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700">
              {reviews.map((review) => (
                <tr key={review.id} className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400 font-medium">
                    {format(new Date(review.created_at), 'yyyy. MMMM d. HH:mm', { locale: hu })}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-bold text-gray-900 dark:text-white">{review.name}</div>
                    <div className="text-sm text-gray-500 dark:text-gray-400">{review.email}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex text-yellow-400">
                      {[...Array(review.star_rating)].map((_, i) => (
                        <SafeIcon key={i} name="Star" className="w-4 h-4 fill-current" />
                      ))}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm text-gray-900 dark:text-gray-200 italic max-w-lg break-words">
                      "{review.message}"
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {reviews.length === 0 && (
            <div className="text-center py-16">
              <div className="w-16 h-16 bg-gray-50 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon name="Inbox" className="w-8 h-8 text-gray-400 dark:text-gray-500" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-1">Még nincs visszajelzés</h3>
              <p className="text-gray-500 dark:text-gray-400">Eddig minden rendben – még nem érkezett negatív visszajelzés.</p>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default Reviews;
